import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const setDisputeReviewed = unaryRpc({
  name: "setDisputeReviewed" as const,
  input: z.object({ disputeId: z.string(), reviewed: z.boolean() }),
  output: z.object({ success: z.boolean() }),
});
